<div nz-row class="content">
  <!--  左侧图谱-->
  <div class="atlas-box relative">
    <div class="bg-white px-lg section-title border-bottom">
      <nz-tabs (nzSelectedIndexChange)="onTabChange($event)" [nzSelectedIndex]="index">
        <nz-tab [nzDisabled]="atlasSrv.isStartV2" nzTitle="知识图谱v1.0"></nz-tab>
        <nz-tab [nzTitle]="v2"></nz-tab>
      </nz-tabs>

      <ng-template #v2> 知识图谱v2.0 <span class="p-[4px] rounded-full bg-red-500 text-white">新</span></ng-template>
      <!--      <h5 style="margin-bottom: 0" nz-typography>{{ atlasSrv.nodeList?.title }}</h5>-->
    </div>

    <div class="atlas">
      <fl-atlas-school></fl-atlas-school>
    </div>

    <div class="bg-white absolute bottom-0 left-0 right-0 px-[16px] py-[8px]">
      <div class="flex justify-between">
        <div>
          <span>显示层级至：</span>
          <button nz-button nzType="link" (click)="changeLevel(1)">第一级</button>
          <button nz-button nzType="link" (click)="changeLevel(2)">第二级</button>
          <button nz-button nzType="link" (click)="changeLevel(3)">第三级</button>
        </div>
        <div>
          <button nz-button nzType="link" (click)="changeDisable(!atlasSrv.isDisableBtn)">
            {{ atlasSrv.isDisableBtn ? '隐藏' : '显示' }}已禁用
          </button>
          <!--          <span> / </span>-->
          <!--          <button nz-button nzType="link" (click)="changeDisable(true)">显示已禁用</button>-->
        </div>
      </div>
    </div>
  </div>

  <!--  右侧知识点内容-->
  <div nz-row class="current-node-box bg-white">
    <div class="node-title py-[11px] px-lg section-title border-bottom">
      @if (!isEditNodeTitle) {
        <div nz-row nzAlign="middle">
          @if (atlasSrv.currentNode?.isOwner) {
            <span
              (click)="isEditNodeTitle = true; changeNodeTitle = atlasSrv.currentNode?.title"
              nz-icon
              nzType="edit"
              nzTheme="outline"
              class="point mr-md"
              style="color: #0065fd"
            ></span>
          }
          <h5
            [nz-tooltip]="$safeNavigationMigration(atlasSrv.currentNode?.title)"
            nzTooltipPlacement="bottom"
            style="margin-bottom: 0"
            nz-typography
            [nzDisabled]="!atlasSrv.currentNode?.isVisible"
          >
            @if (!atlasSrv.currentNode?.isVisible) {
              <span class="mr-sm ellipsis node-max-width" nz-icon nzType="stop" nzTheme="outline"></span>
            }
            {{ atlasSrv.currentNode?.title }}
          </h5>
        </div>
      } @else {
        <div class="flex">
          <input class="mr-sm" nz-input placeholder="请输入知识点名称" [(ngModel)]="changeNodeTitle" />
          <button class="text-weight padding-0" nz-button nzType="primary" (click)="changeTitle()">确定</button>
        </div>
      }
    </div>

    <div class="px-lg nodes-content">
      @if (isShowAlert && !atlasSrv.isStartV2 && index === 1) {
        <nz-alert
          class="mt-md"
          nzShowIcon
          nzType="info"
          nzMessage="推荐使用教学图谱V2.0"
          [nzDescription]="description"
        ></nz-alert>

        <ng-template #description>
          <span
            >教学图谱V2.0颗粒度更划分更详细，可帮助教师和学生更精准定位个性问题；完整预设题目与题库知识点匹配关系，可随时获取历年真题、最新模拟题及相关数据，相似题推荐更加精准。支持添加自定义知识点及管理，满足个性化需求。</span
          >
          <!--        <div class="text-right pt-sm">-->
          <!--          <nz-space>-->
          <!--            <button *nzSpaceItem nz-button nzType="text" (click)="isShowAlert = false">知道了</button>-->
          <!--            <button *nzSpaceItem nz-button nzType="link" (click)="startV2()">启用2.0</button>-->
          <!--          </nz-space>-->
          <!--        </div>-->
        </ng-template>
      }

      <!--    父级关系-->
      @if (atlasSrv.parentNodes?.length > 0) {
        <div class="border-bottom py-lg">
          <div class="flex justify-between">
            <p nz-typography><strong>父级关系</strong></p>
            @if (atlasSrv.parentNodes?.length > 2 && atlasSrv.currentNode.isOwner) {
              <button class="text-weight padding-0" (click)="openAssignParent()" nz-button nzType="link">编辑</button>
            }
          </div>
          <nz-breadcrumb nzSeparator=">">
            @for (item of atlasSrv.parentNodes; track item) {
              <nz-breadcrumb-item (click)="tapChildNode(item, true)"
                ><a>{{ item.title }}</a></nz-breadcrumb-item
              >
            }
          </nz-breadcrumb>
        </div>
      }
      <!--      子集知识点-->
      <div class="border-bottom py-lg" #nodeList>
        <div nz-row nzJustify="space-between" nzAlign="middle">
          <p nz-typography><strong>子集知识点</strong></p>

          <div>
            @if (atlasSrv.parentNodes?.length < 8) {
              @if (
                !atlasSrv.currentNode?.isLeaf ||
                (atlasSrv.currentNode?.isLeaf && atlasSrv.currentNode.chapterNodes?.length === 0)
              ) {
                <button
                  class="text-weight padding-0"
                  [disabled]="!atlasSrv.currentNode?.isVisible || btnIsDisable"
                  (click)="changeMode('add')"
                  nz-button
                  nzType="link"
                >
                  <span nz-icon nzType="plus" nzTheme="outline"></span>添加
                </button>
              }
            }
            @if (childEditMode !== 'select') {
              <button
                class="text-weight padding-0"
                [disabled]="!atlasSrv.currentNode?.isVisible || atlasSrv.childrenNodes?.length <= 0 || btnIsDisable"
                (click)="changeMode('select')"
                nz-button
                nzType="link"
              >
                选择
              </button>
            }
            @if (childEditMode === 'select') {
              <button class="text-weight padding-0" nz-button nzType="text" (click)="childEditMode = 'normal'">
                取消选择
              </button>
            }
          </div>
        </div>

        <ul nz-list [nzSplit]="false">
          @for (item of atlasSrv.childrenNodes; track item) {
            <li
              class="children-node-list-item"
              [class.child-item-hover]="atlasSrv.currentNode?.isVisible && item.isVisible"
              nz-list-item
              (click)="tapChildNode(item, false)"
            >
              <div style="width: 100%; padding: 4px" nz-row nzJustify="space-between" nzAlign="middle">
                <span
                  class="ellipsis node-max-width"
                  [class.child-item-hover]="atlasSrv.currentNode?.isVisible && item.isVisible"
                  style="flex: 1"
                  nz-typography
                  [nzDisabled]="!atlasSrv.currentNode?.isVisible || !item.isVisible"
                  [nz-tooltip]="item.title"
                >
                  @if (childEditMode === 'select') {
                    <label class="mr-sm" nz-checkbox [(ngModel)]="item.checked"></label>
                  }
                  @if (!atlasSrv.currentNode?.isVisible || !item.isVisible) {
                    <span class="mr-sm" nz-icon nzType="stop" nzTheme="outline"></span>
                  }
                  {{ item.title }}</span
                >
                <span class="ml-sm" nz-icon nzType="right" nzTheme="outline"></span>
              </div>
            </li>
          }

          <!--          添加知识点-->
          @if (childEditMode === 'add') {
            <li nz-list-item>
              <input #add_nodes class="mr-sm" nz-input placeholder="请输入知识点名称" [(ngModel)]="addNodeName" />
              <button class="text-weight padding-0" nz-button nzType="primary" (click)="addNode()">添加</button>
            </li>
          }
        </ul>
      </div>

      <!--      关联题库知识点-->
      @if (atlasSrv.childrenNodes && atlasSrv.childrenNodes.length <= 0) {
        <div class="border-bottom py-lg">
          <div nz-row nzAlign="middle" nzJustify="space-between">
            <div>
              @if (atlasSrv.currentNode?.chapterNodes?.length <= 0) {
                <span class="mr-sm" style="color: #ea0000" nz-icon nzType="warning" nzTheme="outline"></span>
              }
              <span nz-typography><strong> 关联题库知识点</strong></span>
              <span
                class="ml-sm"
                nz-icon
                nzType="info-circle"
                nzTheme="outline"
                nz-tooltip="图谱知识点与题库知识树的关联，通过关联关系，知识点可随时从题库中获取相似题、真题数据、学习资源等内容。"
              ></span>
            </div>
            @if (atlasSrv.currentNode.isOwner) {
              <button
                class="text-weight padding-0"
                [disabled]="!atlasSrv.currentNode?.isVisible"
                nz-button
                nzType="link"
                (click)="atlasSrv.assignXkwNode()"
              >
                关联
              </button>
            }
          </div>
          <!--        知识点列表-->
          @if (atlasSrv.currentNode?.chapterNodes?.length <= 0) {
            <div>
              <div class="empty-node mt-sm">未关联题库知识点，无法获取相关题目推荐及真题数据分析。</div>
            </div>
          }

          @if (atlasSrv.currentNode?.chapterNodes?.length > 0) {
            <div>
              @for (item of atlasSrv.currentNode.chapterNodes; track item) {
                <nz-tag class="mb-sm">{{ item.title }}</nz-tag>
              }
            </div>
          }
        </div>
      }

      <div class="text-right mt-md">
        @if (childEditMode === 'normal') {
          <button
            class="text-weight padding-0"
            nz-button
            [disabled]="btnIsDisable"
            [nzDanger]="$safeNavigationMigration(atlasSrv.currentNode?.isVisible)"
            [nzType]="atlasSrv.currentNode?.isVisible ? 'text' : 'link'"
            (click)="forbiddenNode($safeNavigationMigration(atlasSrv.currentNode?.isVisible))"
          >
            {{ atlasSrv.currentNode?.isVisible ? '禁用' : '取消禁用' }}
          </button>
        } @else if (childEditMode === 'select') {
          <button
            class="text-weight padding-0"
            nz-button
            [disabled]="btnIsDisable"
            [nzDanger]="isChildSelectVisble"
            [nzType]="isChildSelectVisble ? 'text' : 'link'"
            (click)="batchDisableNode()"
          >
            {{ isChildSelectVisble ? '禁用' : '取消禁用' }}
          </button>
        }
      </div>
    </div>
  </div>
</div>

<nz-drawer
  [nzClosable]="false"
  [nzVisible]="isShowAssignParent"
  nzTitle="编辑父级"
  (nzOnClose)="isShowAssignParent = false"
>
  <ng-container *nzDrawerContent>
    <div class="flex flex-col h-full">
      <div class="node-tree" style="flex: 1; overflow-y: auto">
        <!-- atlasSrv.treeNode 为图谱节点（key 为 number），与 NzTreeNodeOptions 声明不匹配 -->
        <nz-tree
          [nzData]="atlasSrv.treeNode"
          [nzSelectedKeys]="selectKeys"
          [nzExpandedKeys]="parentIds"
          (nzClick)="clickNode($event)"
        ></nz-tree>
      </div>
      <div class="text-right bg-white pt-sm">
        <button class="text-weight" nz-button nzType="primary" (click)="removeNode()">确定</button>
      </div>
    </div>
  </ng-container>
</nz-drawer>
